import { useMutation, UseMutationOption } from 'src/hooks/use-mutation'
import {
  GqlError,
  ReadNotificationDocument,
  ReadNotificationMutation,
  ReadNotificationMutationVariables,
} from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'

type ReadNotificationReturn = ReadNotificationMutation['readNotification']

const readNotification = async (
  input: ReadNotificationMutationVariables,
): Promise<ReadNotificationReturn> => {
  try {
    const res = await graphqlRequest(ReadNotificationDocument, input)
    return res.readNotification
  } catch (error) {
    throw error
  }
}

export const useReadNotification = (
  option?: UseMutationOption<ReadNotificationReturn, GqlError>,
) => {
  return useMutation(
    (input: ReadNotificationMutationVariables) => readNotification(input),
    option,
  )
}
